import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { Router } from '@angular/router'
import { SharedServices } from '../../../../services/shared.services'
import { RestServices } from '../../../../services/rest.services'

@Component({
    selector: 'app-clinic',
    templateUrl: './clinic.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        '../staff/staff.component.css',
        '../../../../stagingcss/lui-select.component.css'],
})
export class ClinicComponent implements OnInit {
    list: any
    str: any
    en = {}
    showEN = true
    infoUser

    constructor(private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices) {
        this.getCommon()
    }

    getCommon() {
        // set class display theme
        if(localStorage.getItem('classThemeBody')) {
            jQuery('body').attr('class', localStorage.getItem('classThemeBody'))
        }
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                setting: {
                    map: {
                        common: true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                const themeStatus = success['response']['setting']['map']['common']['chooseTheme'] || 'blue'
                if (themeStatus != localStorage.getItem('classThemeBody')) {
                    jQuery('body').attr('class', themeStatus)
                    localStorage.setItem('classThemeBody', themeStatus)
                }
                const checkAddressCommon = success['response']['setting']['map']['common']['address'] || ' '
                const timezone = success['response']['setting']['map']['common']['timezone']
                const countryCode = success['response']['setting']['map']['common']['countryCode']
                if ((!checkAddressCommon || checkAddressCommon === ' ') && (timezone === 'Asia/Tokyo' || timezone === 'Japan' || countryCode === 'JP')) {
                    return this.router.navigateByUrl('/app/main/setting/common')
                }
            })
        })
    }

    ngOnInit() {
        this.listClinics()
        this._sharedService.changeEmittedSource$.subscribe(
            success => {
                this.list = success
            })
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    // list staff
    listClinics() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {

            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    this.list = success['response']['clinic']['paths']['{}']
                    this.infoUser = success['user']['roles']
                },
            )
        })
    }

    editClinic(nameClinic, _idClinic) {
        const arrClinic = [nameClinic, 'activeClinicEdit', _idClinic]
        this._sharedService.emitChange(arrClinic)
    }

    newClinic() {
        this._sharedService.emitChange('activeNewClinic')
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/setting/clinic/clinic.component.ts